/* eslint-disable no-unused-vars */
// Keeping these unused variables so the internalServerError page is shown
define('error/internalServerError',['require','exports','module','i18next'],function (require, exports, module) {
    /* eslint-enable */
    var i18n = require('i18next');
    var self = this;

    self.gcsLink = function () {
        return i18n.t('error.questions.text',
        '<a class="btn-link" href="' + i18n.t('web-urls.urls.g2m.support') + '">',
        '</a>');
    };
});

